<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { $, defineSchema } from '@bagelink/vue'
const schema = defineSchema({
	width: $.select('Width', [
		{ label: 'Narrow', value: 'narrow' },
		{ label: 'Regular', value: 'regular' },
		{ label: 'Wide', value: 'wide' },
		{ label: 'Full', value: 'full' },
	], { default: 'regular' }),
	color: $.select('Color', [
		{ label: 'Default border', value: 'default' },
		{ label: 'Primary', value: 'primary' },
		{ label: 'Gray', value: 'gray' },
	], { default: 'default' }),
	spacing: $.select('Vertical spacing', [
		{ label: 'Compact', value: 'compact' },
		{ label: 'Regular', value: 'regular' },
		{ label: 'Large', value: 'large' },
	], { default: 'regular' }),
})
export const Divider = defineBlock({
	name: 'Divider',
	label: 'Divider',
	icon: 'horizontal_rule',
	thumbnail: '/block-thumbs/Divider.svg',
	category: 'General',
	order: 118,
	schema,
})
</script>
<script setup lang="ts">
import { computed } from 'vue'


const props = defineProps<{
	width?: 'narrow' | 'regular' | 'wide' | 'full'
	color?: 'default' | 'primary' | 'gray'
	spacing?: 'compact' | 'regular' | 'large'
}>()

const widthClass = computed(() => ({
	narrow: 'w-400px',
	regular: 'w-800px',
	wide: 'w-1200px',
	full: 'w-100p',
}[props.width ?? 'regular']))
const colorClass = computed(() => ({
	default: '',
	primary: 'bg-primary',
	gray: 'bg-gray',
}[props.color ?? 'default']))
const spacingClass = computed(() => ({
	compact: 'py-05',
	regular: 'py-1',
	large: 'py-2 m_py-1',
}[props.spacing ?? 'regular']))
</script>

<template>
	<div class="px-1" :class="spacingClass" aria-hidden="true">
		<div class="line" :class="[widthClass, colorClass]" />
	</div>
</template>
